if (process.env.NODE_ENV === 'production'){
    require('./assets/scss/styles.scss'); 
}else{
    require('./assets/scss/app.scss'); 
    require('./assets/scss/styles.scss'); 
}